import React, { useState, useEffect, useRef } from "react"
import { styled } from "../stitches.config";
import { observer } from "mobx-react"
import Cookies from "cookies-js";
import CloseCrossIcon from "../redesign/assets/icons/close-cross-black-icon.svg";
import { IS_STICKY_BAR_TIMEOUT } from '../components/common/constants/constants.js';
import useMediaQuery from '../helpers/useMediaQuery';

const StickyBar = observer(({ id, AdsStore, children }) => {
    const [isHidden, setHidden] = useState(true)
    const [hideStickyBar, setHideStickyBar] = useState(false);
    //const [capped, setCapped] = useState(true) //TODO przenieść wyzej do AdContainer
    const slotHandledRef = useRef(false)
    const [isCloseButtonDisabled, setIsCloseButtonDisabled] = useState(IS_STICKY_BAR_TIMEOUT);
    const isMobile = useMediaQuery('mobile');

    // stara wersja z cappingiem

    // useEffect(() => {
    //     const cookie = Cookies.get(id);
    //     if (typeof cookie === "string") {
    //         console.log(`Anchor has been capped: ${id}`)
    //     } else {
    //         window.googletag.cmd.push(() => {
    //             window.googletag.pubads().addEventListener('slotRenderEnded', (event) => {
    //                 const slotId = event.slot.getSlotElementId()
    //                 console.log('[ES] slotRenderEnded', slotId, event);
    //                 if (slotId === id) {

    //                     // ignorujemy kolejne renderowania tego samego slotu
    //                     if (slotHandledRef.current) return;

    //                     if (!event.isEmpty) {
    //                         slotHandledRef.current = true;
    //                         // capping tylko w przypadku, kiedy reklama nie jest pusta 
    //                         const d = new Date()
    //                         d.setMinutes(d.getMinutes() + AdsStore.adConfig[id]?.capping?.time)

    //                         if (!document.cookie.split(';').some((item) => item.trim().startsWith(id))) {
    //                             document.cookie = id + "=true; path=/; expires=" + d.toUTCString() + "; secure; samesite=lax";
    //                         }

    //                         setHidden(false)
    //                     }
    //                 }
    //             });
    //         });

    //         setCapped(false);
    //     }
    // }, [])

    useEffect(() => {
        window.googletag.cmd.push(() => {
            window.googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                const slotId = event.slot.getSlotElementId();
                if (slotId !== id) return;

                if (slotHandledRef.current) return;
                if (event.isEmpty) return;

                slotHandledRef.current = true;
                setHidden(false);
            });
        });

    }, []);

    const handleClick = (e) => {
        e.preventDefault();
        setHidden(true)
        // TODO to jest brzydko, mozna ew. poprawic
        const container = document.getElementById("belka_sticky")
        container.children[0].remove();
    }

    useEffect(() => {
        if (!isHidden) {

            const t = setTimeout(() => {
                setIsCloseButtonDisabled(false);
            }, 3000);

            return () => clearTimeout(t);
        }
    }, [isHidden]);

    useEffect(() => {
        const recalculate = function () {
            const isExpanderAd = !!document.querySelector("#nat_expander iframe");
            // console.log("EXPANDER_RECALCULATE: ", isExpanderAd, isMobile, hideStickyBar);

            if (isMobile && isExpanderAd) {
                setHideStickyBar(true);
            }
        }
        window.googletag.cmd.push(() => {
            window.googletag.pubads().addEventListener('slotRenderEnded', (event) => {
                const slotId = event.slot.getSlotElementId();
                // console.log("EXPANDER_RECALCULATE: push", slotId);
                if (slotId == "nat_expander") {
                    recalculate();
                }
            });
        });

        recalculate();
    }, []);

    if (hideStickyBar) return null;


    return (
        <StickyWrapper isHidden={isHidden} className="bizon">
            {!isCloseButtonDisabled &&
                <ButtonWrap>
                    <button onClick={handleClick}>
                    </button>
                </ButtonWrap>
            }
            {children}
        </StickyWrapper>
    )
})

const ButtonWrap = styled("div", {
    position: "absolute",
    right: 0,
    zIndex: 10000,
    transform: "translate(-6px, -12px)",
    padding: "3px 4px 0 4px",
    "button": {
        zIndex: "9999",
        margin: 0,
        whiteSpace: "nowrap",
        //fontFamily: "$grotesk",
        //fontStyle: "normal",
        //textShadow: "rgba(0,0,0,.004) 1px 1px 1px !important",
        //color: "#000",
        border: "1px solid $grayscale100Fixed",
        backgroundColor: "transparent",
        borderRadius: "50%",
        backgroundColor: "rgb(255,255,255)",
        backgroundImage: `url("${CloseCrossIcon}")`,
        backgroundPosition: "center",
        backgroundSize: "14px",
        backgroundRepeat: "no-repeat",
        width: "32px",
        height: "32px",
    }
});

const StickyWrapper = styled("div", {
    transition: "transform 1.5s",
    position: "fixed",
    right: 0,
    left: 0,
    bottom: 0,
    zIndex: 10000,
    width: "100%",
    backgroundColor: "rgba(255,255,255,0.9)",
    backgroundColor: "color-mix(in srgb, $grayscale0 90%, transparent)",
    boxShadow: "3px -2px 3px 0 rgba(0,0,0,0.35)",
    // brak animacji dla lepszego CLS
    //transform: "translateY(0px)",
    display: "block",
    // min height dla lepszego CLS przy przeładowaniu nowej reklamy
    minHeight: "100px",
    height: "100px",
    "&.bizon": {
        "@mobile": {
            bottom: "70px",
            background: "white",
            paddingBottom: "15px"
        }
    },
    variants: {
        isHidden: {
            true: {
                // brak animacji dla lepszego CLS
                //transform: "translateY(500px)"
                display: "none",
            }
        }
    }
});

export default StickyBar